export function getPerevedentsevHeight(fontSize) {
  if (fontSize <= 0) {
    return 0;
  }

  if (fontSize < 13) {
    return 32;
  }

  let result;

  if (fontSize <= 15) {
    result = 4 * fontSize - 20;
  } else if (fontSize === 16) {
    result = 48;
  } else {
    result = 2 * fontSize + 16;
  }

  return parseInt(result, 10);
}
